/* Blaize theme JS: cart drawer, AJAX cart, mobile menu. No dependencies. */
(function () {
  'use strict';

  var ROUTES = window.BlaizeRoutes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };

  /* ---------- drawer plumbing ---------- */

  function trapRoot(root, onClose) {
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) onClose();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer(document.getElementById('cart-drawer-root'));
    closeDrawer(document.getElementById('menu-drawer-root'));
  });

  function openDrawer(root) {
    if (!root) return;
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    var closeBtn = root.querySelector('[data-drawer-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closeDrawer(root) {
    if (!root || root.hidden) return;
    root.hidden = true;
    document.body.style.overflow = '';
  }

  function wireDrawers() {
    var cartRoot = document.getElementById('cart-drawer-root');
    var menuRoot = document.getElementById('menu-drawer-root');
    if (cartRoot && !cartRoot.dataset.wired) {
      cartRoot.dataset.wired = '1';
      trapRoot(cartRoot, function () { closeDrawer(cartRoot); });
    }
    if (menuRoot && !menuRoot.dataset.wired) {
      menuRoot.dataset.wired = '1';
      trapRoot(menuRoot, function () { closeDrawer(menuRoot); });
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-cart]')) {
      e.preventDefault();
      openDrawer(document.getElementById('cart-drawer-root'));
    }
    if (e.target.closest('[data-open-menu]')) {
      e.preventDefault();
      openDrawer(document.getElementById('menu-drawer-root'));
    }
  });

  /* ---------- cart state ---------- */

  function updateCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? '(' + count + ')' : '';
    });
  }

  function replaceDrawer(sectionHtml) {
    var root = document.getElementById('cart-drawer-root');
    if (!root || !sectionHtml) return;
    var tpl = document.createElement('div');
    tpl.innerHTML = sectionHtml;
    var fresh = tpl.querySelector('#cart-drawer-root');
    if (!fresh) return;
    var wasOpen = !root.hidden;
    fresh.hidden = !wasOpen;
    root.replaceWith(fresh);
    wireDrawers();
  }

  function refreshFromSections(sections) {
    if (sections && sections['cart-drawer']) replaceDrawer(sections['cart-drawer']);
    return fetch(ROUTES.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCounts(cart.item_count); return cart; });
  }

  function cartError(message) {
    var el = document.querySelector('[data-cart-error]');
    if (el) { el.textContent = message; el.hidden = false; }
    else window.alert(message);
  }

  /* ---------- add to cart ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.dataset.addingLabel || 'Adding…'; }

    var data = new FormData(form);
    data.append('sections', 'cart-drawer');

    fetch(ROUTES.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to bag.');
        return refreshFromSections(res.json.sections);
      })
      .then(function () { openDrawer(document.getElementById('cart-drawer-root')); })
      .catch(function (err) { cartError(err.message); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  });

  /* ---------- cart line changes (drawer + cart page) ---------- */

  var changePending = false;
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-cart-change]');
    if (!el || changePending) return;
    e.preventDefault();
    changePending = true;
    var body = new URLSearchParams();
    body.append('line', el.dataset.line);
    body.append('quantity', el.dataset.quantity);
    body.append('sections', 'cart-drawer');

    fetch(ROUTES.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      body: body.toString()
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || 'Could not update the bag.');
        return refreshFromSections(res.json.sections).then(function (cart) {
          // Cart page renders server-side; reload it so lines and totals stay true.
          if (document.querySelector('[data-cart-page]')) window.location.reload();
          return cart;
        });
      })
      .catch(function (err) { cartError(err.message); })
      .finally(function () { changePending = false; });
  });

  /* ---------- product page: qty stepper + gallery ---------- */

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var input = step.parentElement.querySelector('input[name="quantity"]');
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
      input.value = next;
    }
    var strap = e.target.closest('[data-strap]');
    if (strap) {
      var wrap = strap.closest('.strap-select');
      var input = wrap.querySelector('[data-strap-input]');
      var label = wrap.querySelector('[data-strap-value]');
      if (input) input.value = strap.dataset.strap;
      if (label) label.textContent = strap.dataset.strap;
      wrap.querySelectorAll('[data-strap]').forEach(function (s) {
        s.classList.toggle('is-selected', s === strap);
        s.setAttribute('aria-checked', s === strap ? 'true' : 'false');
      });
      // Swap the main photo when this strap has its own image.
      var imgHost = strap.closest('[data-strap-images]');
      var imgs = [];
      try { imgs = JSON.parse((imgHost && imgHost.dataset.strapImages) || '[]'); } catch (err) {}
      var idx = parseInt(strap.dataset.strapIndex, 10);
      var url = imgs[idx];
      if (url) {
        var gMain = document.querySelector('[data-gallery-main]');
        if (gMain) { gMain.src = url; gMain.removeAttribute('srcset'); }
      }
      // Keep the subtitle's strap colour in sync (e.g. "Champagne dial · Black crocodile strap").
      var sub = document.querySelector('.pdp__sub');
      if (sub) {
        if (sub.dataset.subBase === undefined) sub.dataset.subBase = sub.textContent;
        sub.textContent = sub.dataset.subBase.replace(/(·\s*)([A-Za-z]+)(\s+crocodile)/i, '$1' + strap.dataset.strap + '$3');
      }
    }
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      e.preventDefault();
      var main = document.querySelector('[data-gallery-main]');
      if (main) {
        main.src = thumb.dataset.src;
        if (thumb.dataset.srcset) main.srcset = thumb.dataset.srcset; else main.removeAttribute('srcset');
        main.alt = thumb.dataset.alt || main.alt;
      }
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
    }
  });

  wireDrawers();
})();
